import React from "react";

import mercosul from "../assets/images/mercosul.png";

interface BrazilianPlateProps {
  plate: string;
}

export default function BrazilianPlate({ plate }: BrazilianPlateProps) {
  return (
    <div className="w-40 rounded-lg border-2 border-slate-900 bg-white text-center">
      <div className="flex items-center justify-between rounded-t-[11px] bg-[#003399] px-2 py-1 text-white">
        <img src={mercosul} alt="Mercosul" className="w-6" />
        <span className="text-[10px] font-semibold uppercase tracking-[0.3em]">
          Brasil
        </span>
        <img
          src="https://s1.static.brasilescola.uol.com.br/be/conteudo/images/2-bandeira-do-brasil.jpg"
          alt="Bandeira do Brasil"
          className="w-4 rounded border border-white"
        />
      </div>
      <div className="px-2 py-1 text-xl font-bold tracking-[0.2em] text-slate-900">
        {plate}
      </div>
    </div>
  );
}
